import React from "react";
import PropTypes from "prop-types";

function DropDown(props) {
    let wrapperClass = "row mb-2";
    if (props.error.length > 0) {
        wrapperClass += " has-error";
    }

    let labelClass = "col-form-label "
    let inputClass = "";
    let labelSize = props.label.length;
    if (labelSize >= 25 && labelSize < 40) {
        labelClass += "col-sm-5 col-lg-3";
        inputClass = "col-sm-6 col-lg-3";
    }
    else if (labelSize >= 40) {
        labelClass += "col-sm-6 col-lg-4";
        inputClass = "col-sm-6 col-lg-2";
    }
    else {
        labelClass += "col-sm-3 col-lg-2";
        inputClass = "col-sm-6 col-lg-4";
    }

    function handleChange(event) {
        let isValid = true;
        let value = event.target.value;

        if (value === "") {
            value = "-1";
            isValid = false;
        }
        props.onChange(event, "select", props.id, value, isValid);
    }

    return (
        <div className={wrapperClass}>
            <label className={labelClass} htmlFor={props.id}>
                {props.label}
            </label>
            <div className={inputClass}>
                <select
                    id={props.id}
                    className="form-select"
                    value={props.value || ""}
                    onChange={event => handleChange(event)}
                >
                    {props.list.map(item => {
                        return (
                            <option key={item.id} value={item.id}>
                                {item.text}
                            </option>
                        );
                    })}
                </select>
            </div>
            {props.error && <div className="alert alert-danger">{props.error}</div>}
        </div>
    );
}

DropDown.propTypes = {
    error: PropTypes.string,
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.number,
    list: PropTypes.array.isRequired
};

DropDown.defaultProps = {
    error: "",
    value: ""
};

export default DropDown;
